var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "57px",
    height: "48px",
    viewBox: "0 0 57 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-9",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "30.2-SSO-log-in",
    transform: "translate(-655.000000, -224.000000)",
    stroke: "#3FA8FF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(656.000000, 226.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-1",
    points: "16.8251087 27.7850615 21.7966304 44.8699333 26.999413 32.0099846 53.999413 -0.000117948718"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-3",
    points: "54 -0.000235897436 27 32.0098667 47.52 40.5293026"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-5",
    points: "54 -0.000235897436 0 20.798841 16.8256957 27.7849436"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-7",
    points: "21.796513 44.8698154 34.5452087 35.0399692 27.0979043 31.8919179"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.056a26632dc0e4e44bdc47cba35b343c.svg";
export { ForwardRef as ReactComponent };